import type { Ring } from '../../geometry/types';

export type ShapeupPuzzle = {
  targetId: string;
  targetName: string;
  target: Ring;
  noGoRadius: number;
};

export function isShapeupPuzzle(value: unknown): value is ShapeupPuzzle {
  if (!value || typeof value !== 'object') return false;
  const candidate = value as Partial<ShapeupPuzzle>;
  return (
    typeof candidate.targetId === 'string' &&
    typeof candidate.targetName === 'string' &&
    Array.isArray(candidate.target) &&
    candidate.target.length >= 3 &&
    candidate.target.every(
      (point) =>
        typeof point?.x === 'number' &&
        Number.isFinite(point.x) &&
        point.x >= 0 &&
        point.x <= 1 &&
        typeof point?.y === 'number' &&
        Number.isFinite(point.y) &&
        point.y >= 0 &&
        point.y <= 1,
    ) &&
    typeof candidate.noGoRadius === 'number' &&
    candidate.noGoRadius >= 0.05 &&
    candidate.noGoRadius <= 0.2
  );
}
